import React, { useState, useRef, useEffect } from "react";
import { Phone, X, MessageCircle, Send, Sparkles } from "lucide-react";
import api, { formatApiError } from "../lib/api";
import { useStore } from "../context/StoreContext";

export const FloatingButtons = () => {
  const { settings } = useStore();
  const whatsappNumber = (settings.whatsapp || "919000000000").replace(/\D/g, "");
  const phoneNumber = settings.phone || "+919000000000";
  const [chatOpen, setChatOpen] = useState(false);
  const [messages, setMessages] = useState([
    { role: "assistant", text: "Namaste! I'm your Aadvan concierge. Ask me about our nuts, gifting, nutrition or delivery in Sitapur. 🌰" },
  ]);
  const [input, setInput] = useState("");
  const [loading, setLoading] = useState(false);
  const sessionId = useRef("chat-" + Math.random().toString(36).slice(2));
  const scrollRef = useRef(null);

  useEffect(() => {
    if (scrollRef.current) scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
  }, [messages, chatOpen]);

  const send = async (e) => {
    e.preventDefault();
    const msg = input.trim();
    if (!msg || loading) return;
    setMessages((m) => [...m, { role: "user", text: msg }]);
    setInput("");
    setLoading(true);
    try {
      const { data } = await api.post("/chat", { session_id: sessionId.current, message: msg });
      setMessages((m) => [...m, { role: "assistant", text: data.reply }]);
    } catch (err) {
      setMessages((m) => [...m, { role: "assistant", text: formatApiError(err) }]);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="fixed bottom-6 right-6 z-40 flex flex-col items-end gap-3">
        {chatOpen && (
          <div className="w-[340px] max-w-[calc(100vw-3rem)] bg-white rounded-2xl border border-border shadow-2xl overflow-hidden fade-in" data-testid="live-chat-panel">
            <div className="bg-forest text-cream px-4 py-3 flex items-center justify-between">
              <div className="flex items-center gap-2">
                <Sparkles size={16} className="text-gold" />
                <span className="font-serif text-lg">Aadvan Concierge</span>
              </div>
              <button onClick={() => setChatOpen(false)} data-testid="chat-close"><X size={18} /></button>
            </div>
            <div ref={scrollRef} className="h-80 overflow-y-auto px-3 py-4 space-y-3 bg-cream no-scrollbar">
              {messages.map((m, i) => (
                <div key={i} className={`flex ${m.role === "user" ? "justify-end" : "justify-start"}`}>
                  <div className={`max-w-[80%] text-sm px-3 py-2 rounded-2xl ${m.role === "user" ? "bg-forest text-cream rounded-br-sm" : "bg-white border border-border rounded-bl-sm"}`}>
                    {m.text}
                  </div>
                </div>
              ))}
              {loading && <div className="text-xs text-muted-foreground pl-1">Concierge is typing…</div>}
            </div>
            <form onSubmit={send} className="flex items-center gap-2 border-t border-border p-2 bg-white">
              <input
                data-testid="chat-input"
                value={input}
                onChange={(e) => setInput(e.target.value)}
                placeholder="Type your message…"
                className="flex-1 text-sm px-3 py-2 outline-none bg-transparent"
              />
              <button type="submit" data-testid="chat-send" className="w-9 h-9 rounded-full bg-gold text-forest flex items-center justify-center hover:bg-gold-soft transition-colors">
                <Send size={16} />
              </button>
            </form>
          </div>
        )}

        <div className="flex flex-col gap-3">
          <a href={`https://wa.me/${whatsappNumber}`} target="_blank" rel="noreferrer" data-testid="whatsapp-button"
             className="w-14 h-14 rounded-full bg-[#25D366] text-white flex items-center justify-center shadow-lg hover:scale-105 transition-transform">
            <svg width="26" height="26" viewBox="0 0 24 24" fill="currentColor"><path d="M17.6 6.3A7.85 7.85 0 0 0 12 4a7.94 7.94 0 0 0-6.9 11.9L4 20l4.2-1.1A7.9 7.9 0 0 0 12 20a7.94 7.94 0 0 0 5.6-13.7Zm-5.6 12.2a6.6 6.6 0 0 1-3.4-.9l-.24-.15-2.5.66.67-2.43-.16-.25a6.6 6.6 0 1 1 5.63 3.06Zm3.6-4.94c-.2-.1-1.17-.58-1.35-.64s-.31-.1-.44.1-.51.64-.62.77-.23.15-.43.05a5.4 5.4 0 0 1-1.6-.99 6 6 0 0 1-1.1-1.37c-.12-.2 0-.31.09-.41s.2-.23.3-.35a1.36 1.36 0 0 0 .2-.33.37.37 0 0 0 0-.35c-.05-.1-.44-1.06-.6-1.45s-.32-.33-.44-.34h-.38a.72.72 0 0 0-.52.24 2.2 2.2 0 0 0-.68 1.63 3.8 3.8 0 0 0 .8 2.03 8.75 8.75 0 0 0 3.35 2.96c.47.2.83.32 1.11.42a2.68 2.68 0 0 0 1.23.08 2 2 0 0 0 1.32-.94 1.65 1.65 0 0 0 .11-.93c-.05-.09-.18-.14-.38-.24Z"/></svg>
          </a>
          <a href={`tel:${phoneNumber}`} data-testid="call-button"
             className="w-14 h-14 rounded-full bg-forest text-cream flex items-center justify-center shadow-lg hover:scale-105 transition-transform">
            <Phone size={22} />
          </a>
          <button onClick={() => setChatOpen((o) => !o)} data-testid="chat-toggle"
             className="w-14 h-14 rounded-full bg-gold text-forest flex items-center justify-center shadow-lg hover:scale-105 transition-transform">
            {chatOpen ? <X size={22} /> : <MessageCircle size={22} />}
          </button>
        </div>
      </div>
    </>
  );
};
